import { useMutation } from "@apollo/client";
import createSavedSearchMutation from "../mutation/createSavedSearch.graphql";
import savedSearchesQuery from "../query/savedSearches.graphql";

const useCreateSavedSearch = () => {
  return useMutation(createSavedSearchMutation, {
    awaitRefetchQueries: true,
    refetchQueries: [{ query: savedSearchesQuery }],
  });
};

export default useCreateSavedSearch;
